export default __webpack_public_path__ + "static/media/Employee_Census_Template.5b541819.xlsx";